var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "countdown insicht insicht--fade-up insicht--fast" },
    [
      _vm.timeDiff
        ? _c("div", { staticClass: "countdown__time" }, [
            _c("div", { staticClass: "countdown__time-block" }, [
              _c("span", {
                staticClass: "countdown__time-counter",
                domProps: { innerHTML: _vm._s(_vm.parsedTime.d) }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "countdown__time-label",
                domProps: { innerHTML: _vm._s(_vm.$t("countdown.days")) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "countdown__time-block" }, [
              _c("span", {
                staticClass: "countdown__time-counter",
                domProps: { innerHTML: _vm._s(_vm.parsedTime.h) }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "countdown__time-label",
                domProps: { innerHTML: _vm._s(_vm.$t("countdown.hours")) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "countdown__time-block" }, [
              _c("span", {
                staticClass: "countdown__time-counter",
                domProps: { innerHTML: _vm._s(_vm.parsedTime.m) }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "countdown__time-label",
                domProps: { innerHTML: _vm._s(_vm.$t("countdown.minutes")) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "countdown__time-block" }, [
              _c("span", {
                staticClass: "countdown__time-counter",
                domProps: { innerHTML: _vm._s(_vm.parsedTime.s) }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "countdown__time-label",
                domProps: { innerHTML: _vm._s(_vm.$t("countdown.seconds")) }
              })
            ])
          ])
        : _c("div", {
            staticClass: "countdown__message",
            domProps: { innerHTML: _vm._s(_vm.message) }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }